import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { ImportDocumentsService } from '../../import-documents.service';
import { AgGridI, AgGridPaginationConfig } from 'src/app/shared/components/ag-grid/ag-grid.model';
import { AgGridImportBOMDuplicatesTab, AgGridImportCodecrosswalkDuplicatesTab, AgGridImportCompaniesDuplicatesTab } from './duplicates-tab.model'
import { AgCustomHeaderComponent } from 'src/app/shared/components/ag-grid/ag-custom-header/ag-custom-header.component';
import { Button, CurrentTab, RoutePath } from 'src/app/shared/model/enum';
import { Subscription } from 'rxjs';
import { ImportBOMCommand, ImportCodeCrosswalkData, ImportCompanyCommand } from '../../import-documents.model';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ColDef } from 'ag-grid-community';
import { TabsService } from 'src/app/shared/components/tabs/tabs.service';
import { CodeCrosswalkService } from 'src/app/components/admin/code-crosswalk/code-crosswalk.service';
import { ProgressHelperService } from '../step-progressbar/progress-helper.service';
@Component({
  selector: 'app-duplicates-tab',
  templateUrl: './duplicates-tab.component.html',
  styleUrls: ['./duplicates-tab.component.scss']
})
export class DuplicatesTabComponent implements OnInit {
  @Output() navToError: EventEmitter<boolean> = new EventEmitter();
  flexHeight;
  messageflexHeight;
  private gridApi;
  private gridColumnApi;
  dataModel: AgGridI;
  data: any = [];
  isLoading: boolean = false;

  enumButtonName = Button;
  importCodeCrosswalkData = new ImportCodeCrosswalkData();
  importCompanyCommand = new ImportCompanyCommand();
  importBOMCommand = new ImportBOMCommand();
  sub: Subscription;
  potentialCompanies = [];
  potentialCodeCrosswalk = [];
  public components: {
    [p: string]: any;
  } = {
      agColumnHeader: AgCustomHeaderComponent,
    };
  agGridPaginationConfig = new AgGridPaginationConfig();
  @Input() potentialError: boolean = false;
  @Input() valid: boolean = false;
  @Input() actWidth: number = 0;

  public defaultColDef: ColDef = {
    resizable: true,
    maxWidth: 350
  };
  overlayNoRowsTemplate = '<div class="ag-overlay-no-rows-center">No Records Available</div>';
  currentTab: string;
  importError: boolean = false;
  routeUrl: string;
  routePath = RoutePath;
  tabName = CurrentTab;
  potentialBOM = [];

  constructor(
    public commonService: CommonService,
    public toaster: ToastrService,
    public importDocumentsService: ImportDocumentsService,
    private router: Router,
    public tabsService: TabsService,
    public codeCrosswalkService: CodeCrosswalkService,
    public helperService : ProgressHelperService
  ) {
    this.routeUrl = this.router.url;

    this.tabsService.currentTab.subscribe(res => {
      if (res !== undefined) {
        this.currentTab = res;
      }
    })

    this.sub = this.importDocumentsService.dataPassAccordingToTrackingBar.subscribe(res => {
      this.importError = res?.response?.moduleData?.importError?.length < 1 ? true : false
      if (this.importDocumentsService.indexActive == 4) {
        const res = this.importDocumentsService.dataPassAccordingToTrackingBar.getValue();
        if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
          this.potentialCodeCrosswalk = res?.response?.moduleData?.potentialCodeCrosswalk ?? [];
        } else if(this.currentTab == this.tabName.IMPORT_BOM_TAB){
          this.potentialBOM = res?.response?.moduleData?.potentialBOM ?? [];
        }else {
          this.potentialCompanies = res?.response?.moduleData?.potentialCompanies ?? [];
        }
        this.fillRowData()
      }
    })
  }

  ngOnInit(): void {
    this.commonService.headerHeight.subscribe(res => {
      const width = window.innerWidth;
      this.flexHeight = "calc(100vh - 340px - " + res + "px" + ")";
      this.messageflexHeight = "calc(100vh - 290px - " + res + "px" + ")";

      if (width <= 768) {
        this.flexHeight = "calc(100vh - 360px - " + res + "px)";
        this.messageflexHeight = "calc(100vh - 290px - " + res + "px" + ")";
      } 
      if (this.routeUrl === this.routePath.CODECROSSWALK_ROUTEPATH) {
        this.flexHeight = "calc(100vh - 416px - " + res + "px)";
      }
    });

    if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
      this.dataModel = AgGridImportCodecrosswalkDuplicatesTab;
      //  this.data = [
      //   { type: 'new record', sicCode: 'new record', naicsCode: 'new record', industry: 'new record', action: 'new record' },
      // ]
    }else if(this.currentTab == this.tabName.IMPORT_BOM_TAB){
      this.dataModel = AgGridImportBOMDuplicatesTab;
    } else {
      this.dataModel = AgGridImportCompaniesDuplicatesTab;
    }

  }

  fillRowData() {
    this.isLoading = true;

    if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
      this.data = this.potentialCodeCrosswalk;
      this.data.map((name) => {
        name?.duplicateCodeCrosswalk.sort((a, b) => a.type.localeCompare(b.type))
      });
    }  else if(this.currentTab == this.tabName.IMPORT_BOM_TAB){
      this.data = this.potentialBOM;
      this.data.map((name) => {
        name?.duplicatePotential.sort((a, b) => a.type.localeCompare(b.type))
      });
    }else {
      this.data = this.potentialCompanies;
      this.data.map((name) => {
        name.duplicateCompanies.sort((a, b) => a.type.localeCompare(b.type))
      });
      // this.data=[]
    }
    let array = this.data?.map(x => x?.duplicateCompanies || x?.duplicateCodeCrosswalk)
    if (array?.length > 0)
      this.isLoading = false;


  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  isDataLoaded: boolean = false;

  moveToEnd() {
    if (this.valid) return
    this.isDataLoaded = true;
    if (this.currentTab == this.tabName.CODECROSSWALK_TAB) {
      this.insertCodeCrosswalkData();
    } else if(this.currentTab == this.tabName.IMPORT_BOM_TAB){
      this.insertBOMData();
    }else {
      this.insertData();
    }
  }

  closeTab() {
    if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) {
      this.importDocumentsService.closeVendorTab();
      this.router.navigate([this.routePath.VENDORLIST_ROUTEPATH]);
      this.tabsService.currentTab.next(this.tabName.VENDORLIST_TAB)
    } else if(this.currentTab == this.tabName.IMPORT_BOM_TAB){
      this.importDocumentsService.closeBOMTab();
      this.router.navigate([this.routePath.REQUIREMENT_ROUTEPATH]);
      this.tabsService.currentTab.next(this.tabName.REQUIREMENTS_TAB)
    }else {
      this.importDocumentsService.closeTab();
      this.router.navigate([this.routePath.COMPANY_ROUTEPATH]);
      this.tabsService.currentTab.next(this.tabName.COMPANY_TAB)
    }
  }
  close() {
    this.codeCrosswalkService.valuePopup.next(true)
  }


  insertData() {
    // // ===== TEMPORARY: Force failure for testing stepFail SVG & failed screen =====
    // const fakeFailRes: any = { isSuccess: false, message: 'Forced test failure (duplicates)', response: null };
    // this.importDocumentsService.applyChanges.next(fakeFailRes);
    // this.importDocumentsService.toEnd.next(fakeFailRes);
    // this.toaster.error(fakeFailRes.message);
    // this.isDataLoaded = false;
    // return;
    // // ===== END TEMPORARY =====

    const insertList = [];
    this.data.map((a) => {
      let data = a.duplicateCompanies.find(b => b.action !== undefined);
      if (data) {
        insertList.push(data);
      }
    })
    const data = this.importDocumentsService.dataPassAccordingToTrackingBar.getValue();
    this.importCompanyCommand.companyData = data?.response?.moduleData?.companyData;
    this.importCompanyCommand.importError = data?.response?.moduleData?.importError;
    this.importCompanyCommand.duplicateCompanies = insertList;
    this.importCompanyCommand.templateId = data?.response?.moduleData?.templateId;
    if (this.routeUrl == this.routePath.IMPORTVENDOR_ROUTEPATH) {
      this.importCompanyCommand.isVendor = true;
    }
    this.importDocumentsService.insertImportOnlyCompany(this.importCompanyCommand).subscribe({
      next: (res) => {
        this.isDataLoaded = false;
        if (res.isSuccess) {
          this.toaster.success(res.message);
          this.importDocumentsService.applyChanges.next(res);
          this.importDocumentsService.toEnd.next(res);
        } else {
          this.toaster.error(res.message);
          this.importDocumentsService.applyChanges.next(res);
          this.importDocumentsService.toEnd.next(res);
        }
      },
      error: (err) => {
        this.isDataLoaded = false;
        this.toaster.error(err?.error?.message || err?.message || 'An error occurred during import.');
      }
    });
  }

  insertCodeCrosswalkData() {
    // // ===== TEMPORARY: Force failure for testing stepFail SVG & failed screen =====
    // const fakeFailRes: any = { isSuccess: false, message: 'Forced test failure (crosswalk)', response: null };
    // this.importDocumentsService.applyChanges.next(fakeFailRes);
    // this.importDocumentsService.toEnd.next(fakeFailRes);
    // this.toaster.error(fakeFailRes.message);
    // this.isDataLoaded = false;
    // return;
    // // ===== END TEMPORARY =====

    const insertList = [];
    this.data.map((a) => {
      let data = a.duplicateCodeCrosswalk.find(b => b.action !== undefined);
      if (data) {
        insertList.push(data);
      }
    });

    const data = this.importDocumentsService.dataPassAccordingToTrackingBar.getValue();
    this.importCodeCrosswalkData.codeCrosswalkData = data?.response?.moduleData?.codeCrosswalkData;
    this.importCodeCrosswalkData.importError = data?.response?.moduleData?.importError;
    this.importCodeCrosswalkData.duplicateCodeCrosswalk = insertList;
    this.importCodeCrosswalkData.templateId = data?.response?.moduleData?.templateId;
    this.importDocumentsService.insertImportCodeCrosswalk(this.importCodeCrosswalkData).subscribe({
      next: (res) => {
        this.isDataLoaded = false;
        if (res.isSuccess) {
          this.toaster.success(res.message);
          this.importDocumentsService.applyChanges.next(res);
          this.importDocumentsService.toEnd.next(res);
        } else {
          this.toaster.error(res.message);
          this.importDocumentsService.applyChanges.next(res);
          this.importDocumentsService.toEnd.next(res);
        }
      },
      error: (err) => {
        this.isDataLoaded = false;
        this.toaster.error(err?.error?.message || err?.message || 'An error occurred during import.');
      }
    });
  }

  insertBOMData() {
    // // ===== TEMPORARY: Force failure for testing stepFail SVG & failed screen =====
    // const fakeFailRes: any = { isSuccess: false, message: 'Forced test failure (BOM)', response: null };
    // this.importDocumentsService.applyChanges.next(fakeFailRes);
    // this.importDocumentsService.toEnd.next(fakeFailRes);
    // this.toaster.error(fakeFailRes.message);
    // this.isDataLoaded = false;
    // return;
    // // ===== END TEMPORARY =====

    const insertList = [];
    this.data.map((a) => {
      let data = a.duplicatePotential.find(b => b.action !== undefined);
      if (data) {
        insertList.push(data);
      }
    });

    const data = this.importDocumentsService.dataPassAccordingToTrackingBar.getValue();
    this.importBOMCommand.data = data?.response?.moduleData?.data;
    this.importBOMCommand.importError = data?.response?.moduleData?.importError;
    this.importBOMCommand.duplicatePotential = insertList;
    this.importBOMCommand.templateId = data?.response?.moduleData?.templateId;
    this.importDocumentsService.insertImportBOM(this.importBOMCommand).subscribe({
      next: (res) => {
        this.isDataLoaded = false;
        if (res.isSuccess) {
          this.toaster.success(res.message);
          this.importDocumentsService.applyChanges.next(res);
          this.importDocumentsService.toEnd.next(res);
        } else {
          this.toaster.error(res.message);
          this.importDocumentsService.applyChanges.next(res);
          this.importDocumentsService.toEnd.next(res);
        }
      },
      error: (err) => {
        this.isDataLoaded = false;
        this.toaster.error(err?.error?.message || err?.message || 'An error occurred during import.');
      }
    });
  }

  navigateToErrorTab() {
    this.navToError.emit(true)
  }

}
